var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-img-container"},[_c('div',{staticClass:"logo"},[_vm._t("logo")],2),_vm._v(" "),_c('img',{staticClass:"main-img",attrs:{"src":_vm.src,"alt":"Main"}}),_vm._v(" "),_c('div',{staticClass:"main-img-overlay"}),_vm._v(" "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:(_vm.scrollTo),expression:"scrollTo"}],staticClass:"scroll-down",attrs:{"href":"#"}},[_vm._v("V")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a2e3a98","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainPicture.vue
// module id = null
// module chunks = 